import { takeLatest } from 'redux-saga/effects';
import sagaActions from '../../actions/index';

import {
  addNewRouteSaga,
  getAllRoutesSaga,
  deleteRouteSaga,
  editRouteSaga,
  assingEmployee,
  getEmployeeVendorsSaga,
  clearEmployeeVendorsSaga,
} from './routeSaga';

export function* routeSaga() {
  yield takeLatest(sagaActions.ADD_ROUTE, addNewRouteSaga);
  yield takeLatest(sagaActions.GET_ALL_ROUTE, getAllRoutesSaga);
  yield takeLatest(sagaActions.DELETE_ROUTE, deleteRouteSaga);
  yield takeLatest(sagaActions.EDIT_ROUTE, editRouteSaga);
  yield takeLatest(sagaActions.ASSIGN_EMPLOYEE_ON_ROUTE, assingEmployee);
  yield takeLatest(sagaActions.GET_EMPLOYEE_VENDORS, getEmployeeVendorsSaga);
  yield takeLatest(sagaActions.CLEAR_EMPLOYEE_VENDORS, clearEmployeeVendorsSaga);
}
